import React, { Component } from 'react';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import CourseEditor from '../components/courseEditor';
import VideoEditor from '../components/videoEditor';
import CoverEditor from '../components/covertEditor';

const styles = theme => ({
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: 1100,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
});

class EditCourse extends Component {
    render() {
        const { classes, history, match } = this.props
        return (
            <main>
                <div className={classNames(classes.layout, classes.cardGrid)}>
                    <Grid container spacing={24}>
                        <Grid item xs={12} sm={6}>
                            <Grid item x={12}>
                                <CourseEditor history={history} courseId={match.params.id} />
                            </Grid>
                            <Grid item x={12}>
                                <CoverEditor courseId={match.params.id} />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <VideoEditor courseId={match.params.id} />
                        </Grid>
                    </Grid>
                </div>
            </main>
        );
    }
}

export default withStyles(styles)(EditCourse);